<div class="uk-section ">
    <div class="uk-container uk-flex-center">
        <div class=" uk-child-width-1-3@s uk-child-width-1-4@m uk-grid-match" uk-grid>
            <div  uk-lightbox="animation: fade">
                
                <a class="uk-inline" href="assets/portfolio/fruit3.jpg" data-caption="Fruits">
                    <img src="assets/portfolio/fruit3.jpg" style="height: 500px; width: 400px;"  alt="" uk-img>
                </a>
           
            </div>
            <div uk-lightbox="animation: fade">
             
                    <a  href="assets/portfolio/gourmet.2.jpg" data-caption="Shop by category">
                        <img src="assets/portfolio/gourmet.2.jpg" style="height: 500px; width: 400px;" alt="" uk-img>
                    </a>
            </div>
           
            <div uk-lightbox="animation: fade">
             
                    <a class="uk-inline" href="assets/portfolio/beauty.1.jpg" data-caption="The beauty store">
                        <img src="assets/portfolio/beauty.1.jpg" style="height: 500px; width: 400px;" alt="" uk-img>
                    </a>
            </div>
          
            <div uk-lightbox="animation: fade">
                
                    <a class="uk-inline" href="assets/portfolio/bakery.1.jpg" data-caption="Bakery, cakes and diarys">
                        <img src="assets/portfolio/bakery.1.jpg" style="height: 500px; width: 400px;"  alt="" uk-img>
                    </a>
               
            </div>
            
            <div uk-lightbox="animation: fade">
                
                <a class="uk-inline" href="assets/portfolio/cart.jpg" data-caption="Cart">
                    <img src="assets/portfolio/cart.jpg"style="height: 500px; width: 400px;"  alt="" uk-img>
                </a>
           
            </div>
            <div  class="uk-child-width-1-1@m" uk-grid uk-lightbox="animation: fade">
                
                <a class="uk-inline" href="assets/portfolio/category.1.jpg" data-caption="Category1">
                    <img src="assets/portfolio/category.1.jpg" style="height: 500px; width: 400px;"  alt="" uk-img>
                </a>
       
            </div>
            <div  class="uk-child-width-1-1@m" uk-grid uk-lightbox="animation: fade">
                
                <a class="uk-inline" href="assets/portfolio/category.2.jpg" data-caption="Category2">
                    <img src="assets/portfolio/category.2.jpg" style="height: 500px; width: 400px;" alt="" uk-img>
                </a>
       
            </div>
            <div  class="uk-child-width-1-1@m" uk-grid uk-lightbox="animation: fade">
                
                <a class="uk-inline" href="assets/portfolio/category.3.jpg" data-caption="Category3">
                    <img src="assets/portfolio/category.3.jpg" style="height: 500px; width: 400px;" alt="" uk-img>
                </a>
       
            </div>
            <div  class="uk-child-width-1-1@m" uk-grid uk-lightbox="animation: fade">
                
                <a class="uk-inline" href="assets/portfolio/fruit1.jpg" data-caption="Fruits">
                    <img src="assets/portfolio/fruit1.jpg" style="height: 500px; width: 400px;" alt="" uk-img>
                </a>
       
            </div>
            <div  class="uk-child-width-1-1@m" uk-grid uk-lightbox="animation: fade">
                
                <a class="uk-inline" href="assets/portfolio/fruit2.jpg" data-caption="Fruits">
                    <img src="assets/portfolio/fruit2.jpg" style="height: 500px; width: 400px;" alt="" uk-img>
                </a>
       
            </div>
            <div  class="uk-child-width-1-1@m" uk-grid uk-lightbox="animation: fade">
                
                <a class="uk-inline" href="assets/portfolio/drawer.2.jpg" data-caption="Shop by category">
                    <img src="assets/portfolio/drawer.2.jpg" style="height: 500px; width: 400px;"  alt="" uk-img>
                </a>
       
            </div>
            <div  class="uk-child-width-1-1@m" uk-grid uk-lightbox="animation: fade">
                
                <a class="uk-inline" href="assets/portfolio/fruit2.jpg" data-caption="Fruits1">
                    <img src="assets/portfolio/fruit2.jpg" style="height: 500px; width: 400px;" alt="" uk-img>
                </a>
       
            </div>
            <div  class="uk-child-width-1-1@m" uk-grid uk-lightbox="animation: fade">
                
                <a class="uk-inline" href="assets/portfolio/fruit1.jpg" data-caption="Fruit">
                    <img src="assets/portfolio/fruit1.jpg" style="height: 500px; width: 400px;" alt="" uk-img>
                </a>
       
            </div>
            <div  class="uk-child-width-1-1@m" uk-grid uk-lightbox="animation: fade">
                
                <a class="uk-inline" href="assets/portfolio/homescreen.1.jpg" data-caption="Home screen">
                    <img src="assets/portfolio/homescreen.1.jpg" style="height: 500px; width: 400px;"  alt="" uk-img>
                </a>
       
            </div>
            <div  class="uk-child-width-1-1@m" uk-grid uk-lightbox="animation: fade">
                
                <a class="uk-inline" href="assets/portfolio/homescreen.3.jpg" data-caption="Home screen">
                    <img src="assets/portfolio/homescreen.3.jpg" style="height: 500px; width: 400px;"  alt="" uk-img>
                </a>
       
            </div>
            <div  class="uk-child-width-1-1@m" uk-grid uk-lightbox="animation: fade">
                
                <a class="uk-inline" href="assets/portfolio/loginscreen.jpg" data-caption="Login">
                    <img src="assets/portfolio/loginscreen.jpg" style="height: 500px; width: 400px;" alt="" uk-img>
                </a>
       
            </div>
            <div  class="uk-child-width-1-1@m" uk-grid uk-lightbox="animation: fade">
                
                <a class="uk-inline" href="assets/portfolio/offers.jpg" data-caption="Offers">
                    <img src="assets/portfolio/offers.jpg" style="height: 500px; width: 400px;"  alt="" uk-img>
                </a>
       
            </div>
            <div  class="uk-child-width-1-1@m" uk-grid uk-lightbox="animation: fade">
                
                <a class="uk-inline" href="assets/portfolio/search.jpg" data-caption="Search">
                    <img src="assets/portfolio/search.jpg" style="height: 500px; width: 400px;" alt="" uk-img>
                </a>
       
            </div>
            <div  class="uk-child-width-1-1@m" uk-grid uk-lightbox="animation: fade">
                
                <a class="uk-inline" href="assets/portfolio/signup.jpg" data-caption="Signup">
                    <img src="assets/portfolio/splashscreen.jpg" style="height: 500px; width: 400px;" alt="" uk-img>
                </a>
       
            </div>
            <div  class="uk-child-width-1-1@m" uk-grid uk-lightbox="animation: fade">
                
                <a class="uk-inline" href="assets/portfolio/wheat2.png" data-caption="Add to Cart">
                    <img src="assets/portfolio/wheat2.png" style="height: 500px; width: 400px;" alt="" uk-img>
                </a>
       
            </div>

        </div>
       
    </div>
</div>
